<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-https" /> Objetivos del Concurso
        <div class="card-header-actions">
          <CButton color="danger" size="sm" @click="deleteAllObjectivesModal()"
            v-if="permissions && permissions['challenges.write'] === true">Resetear Objetivos</CButton>
          <CButton color="success" size="sm" @click="importModal()"
            v-if="permissions && permissions['challenges.write'] === true">Importar Objetivos</CButton>
          <CButton color="info" size="sm" @click="storeModal()"
            v-if="permissions && permissions['challenges.write'] === true">Nuevo Objetivo</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable :tableFilter="tableFilter" :hover="hover" :striped="striped" :border="border" :small="small" :fixed="fixed" :items="items"
        :fields="fields" :items-per-page="30" :dark="dark" pagination>
        <template #type="{ item }">
          <td class="w100 text-center" style="font-size: 12px; padding: 0 5px 0 5px !important;">
            <span v-if="item.type === 'sales'">Venta Monto (Total)</span>
            <span v-else-if="item.type === 'customers'">Clientes Cantidad (Diferentes)</span>
            <span v-else-if="item.type === 'boxes'">Cajas Unidad (Cantidad)</span>
            <span v-else>-</span>
          </td>
        </template>
        <template #name="{ item }">
          <td style="font-size: 12px; padding: 0 5px 0 5px !important;">
            <span style="font-weight: bold;">{{ item.name }}</span><br />
            <span>{{ item.description }}</span>
          </td>
        </template>
        <template #target_group="{ item }">
          <td class="w100 text-center" style="font-size: 12px; padding: 0 5px 0 5px !important;">
            <span>{{ item.target_group == 'unique' ? 'Unico' : 'Recurrente' }}</span>
          </td>
        </template>
        <template #target="{ item }">
          <td class="w200 text-left" style="font-size: 12px; padding: 0 5px 0 5px !important;">
            <span>Monto Objetivo: {{ item.target }}</span><br>
            <span>Minimo para participar: {{ item.target_min }}</span><br>
            <span>Maximo para participar: {{ item.target_max }}</span><br>
            <template v-if="item.target_group != 'unique'">
              <span>Inicio de premiación: {{ item.target_init }}</span><br>
            </template>
            <span>Premiación topada a: {{ item.award_max }}</span>
          </td>
        </template>
        <template #award="{ item }">
          <td class="w150 text-left" style="font-size: 12px; padding: 0 5px 0 5px !important;">
            <span v-if="item.award_type === 'digital_points'">Puntos Digitales: </span>
            <span v-else-if="item.award_type === 'wallet'">Monedero Electrónico: </span>
            <span v-else-if="item.award_type === 'ticket'">Boletos para Evento: </span>
            <span v-else-if="item.award_type === 'card'">Tarjeta de Regalo: </span>
            <span v-else-if="item.award_type === 'gift'">Premio Físico: </span>
            <span v-else-if="item.award_type === 'event_points'">Puntos para Eventos: </span>
            <span v-else-if="item.award_type === 'card_points'">Puntos para Certificados: </span>
            <span v-else-if="item.award_type === 'gift_points'">Puntos para Premios: </span>
            <span v-else-if="item.award_type === 'wallet_points'">Puntos para Monedero: </span>
            <span v-else>-</span>
            <span>{{ item.award_amount }}</span>
          </td>
        </template>
        <template #rules="{ item }">
          <td class="w300 text-left" style="font-size: 12px; padding: 0 5px 0 5px !important;">
            <!-- Si no hay reglas ni grupos -->
            <template
              v-if="(!item.rules || item.rules.length === 0) && (!item.ruleGroups || item.ruleGroups.length === 0)">
              <span>Sin reglas asignadas</span>
            </template>

            <!-- Reglas individuales -->
            <template v-if="item.rules && item.rules.length">
              <div v-for="(rule, index) in item.rules" :key="'r_' + rule.id" class="mb-1">
                <span><strong>{{ index + 1 }}.</strong> {{ rule.preview }}</span>
                <span v-if="rule.description" style="font-size: 9px; font-weight: bold;">
                  <br>{{ rule.description }}
                </span>
              </div>
            </template>

            <!-- Grupos de reglas -->
            <template v-if="item.ruleGroups && item.ruleGroups.length">
              <div v-for="(group, gi) in item.ruleGroups" :key="'g_' + group.id" class="border p-2 rounded mb-2">
                <div><strong>Grupo ({{ group.operator }}):</strong> {{ group.description || 'Sin nombre' }}</div>
                <ul class="pl-3 mb-1">
                  <li v-for="(rule, ri) in group.rules" :key="'g_' + gi + '_r_' + ri">
                    {{ rule.preview }}
                    <span v-if="rule.description" style="font-size: 9px; font-weight: bold;">
                      <br>{{ rule.description }}
                    </span>
                  </li>
                </ul>
              </div>
            </template>
          </td>
        </template>
        <template #assignments="{ item }">
          <td class="text-left" style="font-size: 12px; padding: 0 5px 0 5px !important;">
            <div>
              <strong>Vendedores:</strong>
              <span v-if="item.supplier_names.length">
                {{ item.supplier_names.join(', ') }}
              </span>
              <span v-else>Para todos</span>
            </div>
            <div>
              <strong>Clientes:</strong>
              <span v-if="item.customer_names.length">
                {{ item.customer_names.join(', ') }}
              </span>
              <span v-else>Para todos</span>
            </div>
          </td>
        </template>
        <template #actions="{ item }">
          <td class="w100 table_actions b3" style="font-size: 12px; padding: 0 5px 0 5px !important;">
            <CButton title="Asignar Reglas" color="dark" size="sm" @click="asignRules(item)"
              v-if="permissions && permissions['challenges.write'] === true">
              <CIcon name="cil-task" />
            </CButton>
            <CButton title="Asignar Participantes" color="info" size="sm" @click="asignSupplier(item)"
              v-if="permissions && permissions['challenges.write'] === true">
              <CIcon name="cil-user" />
            </CButton>
            <CButton title="Editar Objetivo" color="warning" size="sm" @click="updateModal(item)"
              v-if="permissions && permissions['challenges.write'] === true">
              <CIcon name="cil-pencil" />
            </CButton>
            <CButton title="Eliminar Objetivo" color="danger" size="sm" @click="deleteModal(item)"
              v-if="permissions && permissions['challenges.write'] === true">
              <CIcon name="cil-trash" />
            </CButton>
          </td>
        </template>
        <!-- TD Ocultos para búsqueda global -->
        <template #assignments_text="{ item }">
          <td style="display: none;"></td>
        </template>
      </CDataTable>
    </CCardBody>
    <ChallengeObjectiveModal ref="challengeObjectiveModal" @storeObjectives="storeProcess"
      @updateObjectives="updateProcess"></ChallengeObjectiveModal>
    <AssignSupplierObjectiveModal ref="assignSupplierObjectiveModal"></AssignSupplierObjectiveModal>
    <AssignRulesModal ref="assignRulesModal"></AssignRulesModal>
    <DeleteModal ref="deleteObjective" @delete="deleteProcess"></DeleteModal>
    <ImportObjectivesModal @refresh="refresh" ref="importObjectivesModal"></ImportObjectivesModal>
    <DeleteAllObjectivesModal ref="deleteAllObjectivesModal" @deleteAllObjectives="deleteAllObjectives">
    </DeleteAllObjectivesModal>
  </CCard>
</template>

<script>
import ws from '../../../services/challenges';
import store from '../../../store'
import ChallengeObjectiveModal from './ChallengeObjectiveModal.vue';

import AssignSupplierObjectiveModal from './AssignSupplierObjectiveModal.vue';
import AssignRulesModal from './AssignRulesModal.vue';
import ImportObjectivesModal from './ImportObjectivesModal.vue';
import DeleteModal from '../../global/DeleteModal.vue'
import DeleteAllObjectivesModal from './DeleteAllObjectivesModal.vue';

export default {
  name: 'ChallengeObjectives',
  components: { ChallengeObjectiveModal, AssignSupplierObjectiveModal, AssignRulesModal, DeleteModal, ImportObjectivesModal, DeleteAllObjectivesModal },
  props: {
    permissions: Object,
  },
  data() {
    return {
      toasts: [],
      rate: 100,
      challenge: {
        'type': 'boxes'
      },
      caption: "Objetivos del Concurso",
      hover: true,
      striped: true,
      border: true,
      small: true,
      fixed: true,
      dark: false,
      fields: [
        { key: 'type', label: 'Tipo', _style: "font-size: 12px" },
        { key: 'name', label: 'Objetivo', _style: "font-size: 12px" },
        { key: 'target_group', label: 'Enfoque', _style: "font-size: 12px" },
        { key: 'target', label: 'Monto objetivo', _style: "font-size: 12px" },
        { key: 'award', label: 'Premio', _style: "font-size: 12px" },
        { key: 'rules', label: 'Reglas', _style: "font-size: 12px" },
        { key: 'assignments', label: 'Asignado', _style: "font-size: 12px" },
        { key: 'assignments_text', label: 'Texto Asignaciones', sorter: false, filter: false, _style: 'display: none' },
        { key: 'actions', label: 'Acciones', class: 'actions', _style: "font-size: 12px" },
      ],
      items: [],
      challenge_id: 0,
      tableFilter: {
        label: 'Buscar: ',
        placeholder: '...'
      }
    }
  },
  mounted: async function () {
    this.challenge_id = this.$route.params.challenge_id
    await this.refresh();
  },
  methods: {
    importModal() {
      this.$refs.importObjectivesModal.openModal();
    },
    asignRules(item) {
      this.$refs.assignRulesModal.openModal(item);
    },
    deleteAllObjectivesModal() {
      this.$refs.deleteAllObjectivesModal.showResetModal(this.challenge_id);
    },
    async deleteAllObjectives() {
      this.loading();
      const response = await ws.deleteAllObjectives(this.challenge_id);

      if (response.type == "success") {
        this.showToast("success", "Todos los Objetivos han sido eliminados");
        this.refresh();
      }
      this.loaded();
    },
    async updateProcess(data) {
      this.loading();
      const response = await ws.updateObjectives(data);

      if (response.type == "success") {
        this.showToast("success", "Objetivo Actualizado");
        this.refresh();
      }
      this.loaded();
    },
    storeModal(item) {
      this.$refs.challengeObjectiveModal.storeModal();
    },
    updateModal(item) {
      this.$refs.challengeObjectiveModal.editModal(item);
    },
    asignSupplier(item) {
      this.$refs.assignSupplierObjectiveModal.openModal(item.id);
    },
    deleteModal(item) {
      this.$refs.deleteObjective.show("Eliminar Objetivo", item.id, item.name);
    },
    async storeProcess(data) {
      this.loading();
      const response = await ws.storeObjectives(data);

      if (response.type == "success") {
        this.showToast("success", "Objetivo Añadido");
        this.refresh();
      }
      this.loaded();
    },
    async refresh() {
      this.loading();
      let response = await ws.getObjectives(this.challenge_id);

      if (response.type == "success") {
        this.items = response.data.map(item => {
          return {
            ...item,
            // Texto combinando los valores visibles para búsqueda global
            assignments_text: `Vendedores: ${item.supplier_names?.join(', ') || 'Para todos'} Clientes: ${item.customer_names?.join(', ') || 'Para todos'}`
          };
        });
      }
      this.loaded();
    },
    async deleteProcess(id) {
      let response = await ws.deleteObjectives(id);

      if (response.type == "success") {
        this.showToast("success", "Objetivo Eliminado");
        this.items = response.data.map(item => {
          return {
            ...item,
            // Texto combinando los valores visibles para búsqueda global
            assignments_text: `Vendedores: ${item.supplier_names?.join(', ') || 'Para todos'} Clientes: ${item.customer_names?.join(', ') || 'Para todos'}`
          };
        });
      }
    },
    showToast(type, message) {
      store.commit('toast', { color: type, message: message });
    },
    loading() {
      store.commit('loading');
    },
    loaded() {
      store.commit('loaded');
    },
    slugify(str) {
      return String(str)
        .normalize('NFKD') // split accented characters into their base characters and diacritical marks
        .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
        .trim() // trim leading or trailing whitespace
        .toLowerCase() // convert to lowercase
        .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-'); // remove consecutive hyphens
    }
  }
}
</script>
